import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstance39w6eplghmtxw as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.y2s_1.c2t(6);
  if ($this.y2s_1.d2t() === 4) {
    $this.y2s_1.x2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().ec();
  $l$loop: while ($this.y2s_1.e2t()) {
    var key = $this.z2s_1 ? $this.y2s_1.g2t() : $this.y2s_1.f2t();
    $this.y2s_1.c2t(5);
    var element = $this.h2t();
    // Inline function 'kotlin.collections.set' call
    result.a5(key, element);
    lastToken = $this.y2s_1.i2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.y2s_1.x2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.y2s_1.c2t(7);
  } else if (lastToken === 4) {
    if (!$this.a2t_1) {
      invalidTrailingComma($this.y2s_1);
    }
    $this.y2s_1.c2t(7);
  }
  return new (JsonObject())(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.y2s_1.c2t(6);
  if ($this.y2s_1.d2t() === 4) {
    $this.y2s_1.x2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().ec();
  $l$loop: while ($this.y2s_1.e2t()) {
    var key = $this.z2s_1 ? $this.y2s_1.g2t() : $this.y2s_1.f2t();
    $this.y2s_1.c2t(5);
    var element = yield* $receiver.ys(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.a5(key, element);
    lastToken = $this.y2s_1.i2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.y2s_1.x2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.y2s_1.c2t(7);
  } else if (lastToken === 4) {
    if (!$this.a2t_1) {
      invalidTrailingComma($this.y2s_1);
    }
    $this.y2s_1.c2t(7);
  }
  return new (JsonObject())(result);
}
function readArray($this) {
  var lastToken = $this.y2s_1.i2t();
  if ($this.y2s_1.d2t() === 4) {
    $this.y2s_1.x2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().p2();
  while ($this.y2s_1.e2t()) {
    var element = $this.h2t();
    result.j2(element);
    lastToken = $this.y2s_1.i2t();
    if (!(lastToken === 4)) {
      var tmp0 = $this.y2s_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.h2m_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.x2r(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.y2s_1.c2t(9);
  } else if (lastToken === 4) {
    if (!$this.a2t_1) {
      invalidTrailingComma($this.y2s_1, 'array');
    }
    $this.y2s_1.c2t(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.z2s_1 || !isString) {
    tmp = $this.y2s_1.g2t();
  } else {
    tmp = $this.y2s_1.f2t();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda($this)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda(this$0) {
  return constructCallableReference(function *($this$DeepRecursiveFunction, it, $completion) {
    var tmp0_subject = this$0.y2s_1.d2t();
    var tmp;
    if (tmp0_subject === 1) {
      tmp = readValue(this$0, true);
    } else if (tmp0_subject === 0) {
      tmp = readValue(this$0, false);
    } else if (tmp0_subject === 6) {
      tmp = yield* /*#__NOINLINE__*/readObject_0(this$0, $this$DeepRecursiveFunction, $completion);
    } else if (tmp0_subject === 8) {
      tmp = readArray(this$0);
    } else {
      this$0.y2s_1.x2r("Can't begin reading element, unexpected token");
    }
    return tmp;
  }, 2);
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.y2s_1 = lexer;
        this.z2s_1 = configuration.i2n_1;
        this.a2t_1 = configuration.u2n_1;
        this.b2t_1 = 0;
      }
      h2t() {
        var token = this.y2s_1.d2t();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.b2t_1 = this.b2t_1 + 1 | 0;
          if (this.b2t_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.b2t_1 = this.b2t_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.y2s_1.x2r('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
